import { render, staticRenderFns } from "./profile-ip.vue?vue&type=template&id=50327fac&scoped=true"
import script from "./profile-ip.vue?vue&type=script&lang=js"
export * from "./profile-ip.vue?vue&type=script&lang=js"
import style0 from "./profile-ip.vue?vue&type=style&index=0&id=50327fac&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50327fac",
  null
  
)

export default component.exports